// Libs
import React, { useEffect, useState } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
// isMobile
import { isMobile } from 'react-device-detect';
// Components
import Drawer from '@material-ui/core/Drawer';
import { AppBar } from '@material-ui/core';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
// Context
import { useComponentsPool } from '../../ComponentsPool';
import { useFootBar } from './FootBarContext';
import { useModal } from '../modal/ModalContext';
// SCSS
import './style.footbar.scss';
// Helpers
import { visibleMobileFootbarButtons } from '../users/helper';

const FootBar = () => {
  const [t] = useTranslation();
  const { Component } = useComponentsPool();
  const footBar = useFootBar();
  const modal = useModal();
  const routes = useSelector(state => state.footbar.routes);
  const { getComponentFile } = useComponentsPool();
  const history = useHistory();
  const devices = useSelector(state => state.devices.list);
  const workspaceSettings = useSelector(state => state.workspace.settings);
  const currentUser = useSelector(state => state.users.currentUser);
  const [currentPath, setCurrentPath] = useState(history.location.pathname);
  const visibleFootbarButtons = visibleMobileFootbarButtons(currentUser, history.location.pathname, devices, workspaceSettings)
  const availableViews = [
    {
      path: '/tickets',
      isDisplayed: visibleFootbarButtons.includes('tickets'),
      tabName: t('tickets:tickets'),
      iconName: 'tickets',
      filledIconName: 'ticketsFilled'
    }, {
      path: '/rounds',
      isDisplayed: visibleFootbarButtons.includes('rounds'),
      tabName: t('rounds:planning'),
      iconName: 'rounds',
      filledIconName: 'roundsFilled'
    }, {
      path: '/devices',
      isDisplayed: visibleFootbarButtons.includes('devices'),
      tabName: t('common:devices'),
      iconName: 'devices',
      filledIconName: 'deviceFilled'
    }
  ];
  const displayedViews = availableViews.filter(view => view.isDisplayed);

  if (isMobile) {
    return displayedViews.length > 0 ? (
      <div className={'footbar-bottom-navigation-mobile'}>
        <BottomNavigation
          showLabels
          value={displayedViews.findIndex(view => currentPath === view.path)}
          onChange={(event, value) => {
            setCurrentPath(displayedViews[value].path);
            history.push(displayedViews[value].path);
          }}
        >
          {displayedViews.map(view => (
            <BottomNavigationAction
              label={view.tabName}
              icon={<Component componentName={'Icon'} type={currentPath === view.path ? view.filledIconName : view.iconName} />}
            />
          ))}
        </BottomNavigation>
      </div>
    ) : <></>;
  }
  return (
    <Drawer
      className={classNames([
        'footBar-wrapper',
        { zIndex: modal.getWithFootBar() },
        FOOTBAR_POSITION === 'top' ? 'footBar-wrapper-top' : null,
        modal.isVisible ? 'popup-shown' : null
      ])}
      transitionDuration={FOOTBAR_POSITION === 'top' ? 0 : 220}
      variant="persistent"
      anchor={FOOTBAR_POSITION === 'top' ? 'top' : 'bottom'}
      open={footBar.getIsVisible() || footBar.getSelected().length !== 0 || modal.getWithFootBar()}
    >
      <AppBar position="static">
        <Switch>
          {routes.map(route => (
            <Route
              exact
              key={route.path}
              path={route.path}
              component={getComponentFile(route.component)}
            />
          ))}
        </Switch>
      </AppBar>
    </Drawer>
  );
};

export default withRouter(FootBar);
